import { ICarrierRelationshipInfoFragment } from '../../../../Carrier/graphql/CarrierRelationshipInfoFragment'
import { groupCarrierRelationships } from '../../helpers/groupCarrierRelationships'
import { IUseCarrierRelationshipsModalFormProps } from '../hooks/useCarrierRelationshipsModalForm'
import { TAutocompleteValueSchema } from '../schema/AutocompleteValueSchema'
import { getDefaultAutocompleteTransfixUserValue } from './getDefaultAutocompleteTransfixUserValue'

export const getDefaultValues = (
  carrierRelationships: ICarrierRelationshipInfoFragment[]
): IUseCarrierRelationshipsModalFormProps['defaultValues'] => {
  const {
    primaryCarrierManager,
    primaryCeRep,
    primarySalesRep,
    secondaryCarrierManagers,
    secondaryCeRep,
    secondarySalesReps,
  } = groupCarrierRelationships(carrierRelationships)

  return {
    primaryManager: getDefaultAutocompleteTransfixUserValue(primaryCarrierManager),
    secondaryManagers: secondaryCarrierManagers?.map(
      cm => getDefaultAutocompleteTransfixUserValue(cm) as TAutocompleteValueSchema
    ),
    primaryExperienceRep: getDefaultAutocompleteTransfixUserValue(primaryCeRep),
    secondaryExperienceRep: getDefaultAutocompleteTransfixUserValue(secondaryCeRep),
    primarySalesRep: getDefaultAutocompleteTransfixUserValue(primarySalesRep),
    secondarySalesReps: secondarySalesReps?.map(
      cs => getDefaultAutocompleteTransfixUserValue(cs) as TAutocompleteValueSchema
    ),
  }
}
